module.exports = {"googleAPIKey":"AIzaSyBuvyYfJWem38uw9s92xIP3muV5q3OIra8"}


//////////////////
// WEBPACK FOOTER
// ./src/data/settings.json
// module id = 608
// module chunks = 246501157640856